<template>
  <div class="help">
    <div class="sousu-box">
      <div class="video">
        <video
          src="@/assets/helpbg.webm"
          ref="videos"
          loop
          muted="muted"
          autoplay="autoplay"
          style="width: 100%;"
        ></video>
      </div>

      <div class="search-box">
        <div class="text">服务与支持</div>
        <a-input-search
          placeholder="输入要查找问题的关键词，如：新建商品、创建门店"
          enter-button="搜索"
          size="large"
        />
      </div>
    </div>
    <div class="use-box">
      <div class="use-text">
        <div class="text1">快速入门 使用帮助</div>
        <div class="text2">简明的产品入门文档，帮助您快速上手使用产品</div>
      </div>
      <div class="box1">
        <div class="for-time-box">
          <div class="time">丰派POS-收银</div>
          <div class="jies-box">
            <div class="jie">
              <div class="img-text">
                <img v-lazy="require('@/assets/jies.png')" class="img" alt="" />
                <div class="text">产品介绍</div>
              </div>
              <div class="span-text">
                <span class="span"></span>
                <div>什么是智慧零售？</div>
              </div>
              <div class="span-text">
                <span class="span"></span>
                <div>什么是智慧零售？</div>
              </div>
              <div class="span-text">
                <span class="span"></span>
                <div>什么是智慧零售？什么是智慧零售？</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PcHelp",

  data() {
    return {};
  },
  activated() {
    this.play();
  },

  mounted() {},

  methods: {
    play() {
      this.$refs.videos.play();
    },
  },
};
</script>


<style lang="less" scoped>
.help {
  width: 100%;
  min-width: 1420px;
  position: relative;
  top: 64px;
  .sousu-box {
    position: relative;
    .video{
      width: 100%;
      height: 480px;
      overflow: hidden;

    }
    .search-box {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 560px;
      transform: translate(-50%, -50%);
      .text {
        text-align: center;
        font-size: 72px;
        line-height: 88px;
        color: #292929;
        margin-bottom: 10%;
      }
    }
  }

  .use-box {
    width: 100;
    padding: 58px 0 30px;
    .use-text {
      width: 1200px;
      margin: 0 auto;
      text-align: center;
      .text1 {
        font-size: 32px;
        line-height: 42.23px;
        margin-bottom: 10px;
        color: #333333;
      }
      .text2 {
        font-size: 16px;
        line-height: 21.12px;
        color: #626e81;
      }
    }
    .box1 {
      margin-top: 88px;
      width: 1200px;
      margin: 0 auto;
      .for-time-box {
        .time {
          font-size: 22px;
          line-height: 30px;
          color: #202d40;
          margin-bottom: 40px;
        }
        .jies-box {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          margin-top: 40px;
          .jie {
            width: 360px;
            height: 160px;
            padding: 0 40px 0 16px;
            .img-text {
              display: flex;
              height: 32px;
              align-items: center;
              margin-bottom: 18px;
              .img {
                width: 32px;
                height: 32px;
                margin-right: 10px;
              }
              .text {
                font-size: 18px;
                line-height: 26px;
                color: #202d40;
              }
            }
            .span-text {
              font-size: 16px;
              line-height: 24px;
              display: flex;
              align-items: center;
              .span {
                display: inline-block;
                width: 4px;
                height: 4px;
                border-radius: 50%;
                background: #626e81;
                margin-right: 8px;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/help.vue